













































































































import { AuthApi, User, UsersApi } from '@/api';
import Toast from '@/components/display/toast.vue';
import { Component, Prop, PropSync, Vue, Watch } from 'vue-property-decorator';

@Component
export default class UsersTable extends Vue {
	@Prop(Array) public localUsers!: any[];
	@Prop(Array) public allowedUserIds!: number[] | null;
	@Prop(String) public entityType!: string;

	public accessFields: any[] | null = [
		{ key: 'id', label: 'Id', sortable: true },
		{ key: 'name', label: 'Name', sortable: true },
		{ key: 'email', label: 'Email', sortable: true },
		{ key: 'phone', label: 'Phone', sortable: true },
		{ key: 'pivot.permission', label: 'Permission', sortable: true },
		{ key: 'role', label: 'Role', sortable: true },
		// {key: 'permission', label: 'Level'},
		{ key: 'remove', label: 'Remove', thClass: 'text-center' },
		{ key: 'login', label: 'Login', thClass: 'text-center' },
		{ key: 'zendeskId', label: 'ZenDesk', thClass: 'text-center' },
	];

	public mounted() {
		this.refreshAccessFields();
	}

	@Watch('allowedUserIds')
	@Watch('localUsers')
	private refreshAccessFields() {
		if (this.accessFields == null) return;
		const restrictionsFieldIndex = this.accessFields.findIndex(
			field => field.key === 'restrictions',
		);
		if (this.allowedUserIds != null && this.allowedUserIds.length < this.localUsers.length) {
			if (restrictionsFieldIndex === -1)
				this.accessFields.push({ key: 'restrictions', label: 'Restrictions' });
		} else if (restrictionsFieldIndex !== -1) this.accessFields.splice(restrictionsFieldIndex, 1);
	}

	public async changePermission(id: number) {
		const userId = id;
		const { productId } = this.$route.params;
		const permissions = { productId: parseInt(productId, 10) };
		try {
			await new UsersApi().userPermissionChange(parseInt(userId, 10), { data: permissions });
		} catch (e) {
			let error;
			if (e.response) {
				error = 'permission not changed' + e.response.data.message;
			} else if (e.request) {
				error = 'permission not changed, network Error';
			} else {
				error = 'permission not changed, unknown Error';
			}
			new Toast().makeToast(error, 'Error changing permission', 'danger', true);
			this.submitStatus = 'ERROR';
			return;
		}
		new Toast().makeToast('Permission Changed', 'User Permission', 'success');
		this.$emit('loadUsers');
	}

	public async loginAs(id: number) {
		const response = await new AuthApi().loginAsUrl(parseInt(id, 10), {});
		window.open(response.data, '_blank');
	}

	public async detachPermission(id: number) {
		if (confirm(`Are you sure you wish to remove user ${id} permission from this product`)) {
			const userId = id;
			const { productId } = this.$route.params;
			const permission = { action: 'detach', productId: parseInt(productId, 10) };
			try {
				await new UsersApi().userPermission(parseInt(userId, 10), { data: permission });
			} catch (e) {
				let error;
				if (e.response) {
					error = 'user not removed ' + e.response.data.message;
				} else if (e.request) {
					error = 'user not removed, network Error';
				} else {
					error = 'user not removed, unknown Error';
				}
				new Toast().makeToast(error, 'Error removing User', 'danger', true);
				this.submitStatus = 'ERROR';
				return;
			}
			new Toast().makeToast('User: ' + userId + ' removed', 'Successfully Removed', 'success');
			this.submitStatus = 'OK';
			this.$emit('loadUsers');
		}
	}

	public async detachRole(id: number, roleId: number) {
		if (confirm(`Are you sure you wish to remove user ${id} role from this organisation`)) {
			const { orgId } = this.$route.params;
			const role = { action: 'detach', roleId, orgId: parseInt(orgId, 10) };
			try {
				await new UsersApi().userRoles(parseInt(id, 10), { data: role });
			} catch (e) {
				let error;
				if (e.response) {
					error = 'user not removed ' + e.response.data.message;
				} else if (e.request) {
					error = 'user not removed, network Error';
				} else {
					error = 'user not removed, unknown Error';
				}
				new Toast().makeToast(error, 'Error removing User', 'danger', true);
				this.submitStatus = 'ERROR';
				return;
			}
			new Toast().makeToast('User: ' + id + ' removed', 'Successfully Removed', 'success');
			this.submitStatus = 'OK';
			this.$emit('loadUsers');
		}
	}
}
